module.exports = __webpack_public_path__ + "img/activePageMBgZh.cb33c94c.png";